import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface ConfigureCommand {
  vendor: string;
  model: string;
}

export interface ConfigureResponse {
  apiCorrelationToken: string;
}

const client = createClient('/rest/operator-api/charging-stations');

export const configure: SaveOperation<ConfigureCommand, ConfigureResponse, string> = postRequestFactory<
  ConfigureCommand,
  ConfigureResponse,
  string
>(client, { pattern: '/{chargingStationId}/configure', permissionId: commandPermissions.CONFIGURE });
